import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

export const useDefaultIndex = (tabListNew) => {
  const dispatch = useDispatch();
  const [defaultIndex, setDefaultIndex] = useState(0);
  const prevDefaultIndex = useRef(0);

  useEffect(() => {
    setDefaultIndex(0);
  }, [dispatch]);

  useEffect(() => {
    if (tabListNew) {
      for (let i = 0; i < tabListNew.length; i++) {
        if (tabListNew[i].completed === 0) {
          setDefaultIndex(i);
          break;
        }
      }
    }
  }, [dispatch, tabListNew]);

  useEffect(() => {
    prevDefaultIndex.current = defaultIndex;
  }, [defaultIndex]);

  return { defaultIndex, setDefaultIndex, prevDefaultIndex };
};
